<template>
  <div class="sat-language-modal">
    <div class="body2 mb-4">{{ $t("modals.selectSatLanguage.description") }}</div>

    <v-select
      v-model="localValue.preferredLanguageCode"
      :items="localesBasedOnRegion"
      variant="outlined"
      :label="$t('myAccount.profile.language')"
      :placeholder="$t('myAccount.profile.language')"
      persistent-hint
    >
      <template #selection="{ item }">
        <span class="body2">
          {{ $t(`general.localeDisplayNames.${item.raw}`) }}
        </span>
      </template>
      <template #item="{ item, props }">
        <v-list-item
          v-bind="props"
          :title="$t(`general.localeDisplayNames.${item.raw}`)"
        ></v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { isEuEnv } from "@/constants/general.ts";
import { SAT_EU_LOCALES, SAT_GLOBAL_LOCALES, SatLocale } from "@/constants/security-awareness.ts";

export default defineComponent({
  props: {
    disable: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:localValue", "dismissed"],
  setup(props, { emit }) {
    const localValue = ref<{ preferredLanguageCode: SatLocale }>({
      preferredLanguageCode: isEuEnv ? SatLocale.EN_GB : SatLocale.EN_US,
    });

    watch(
      () => localValue.value.preferredLanguageCode,
      () => {
        emit("update:localValue", { ...localValue.value });
      },
      { immediate: true }
    );

    const localesBasedOnRegion = computed(() => {
      return isEuEnv ? SAT_EU_LOCALES : SAT_GLOBAL_LOCALES;
    });

    return {
      localesBasedOnRegion,
      localValue,
    };
  },
});
</script>

<style scoped lang="scss">
.sat-language-modal {
  min-width: 300px;
}
</style>
